const uppercaseFirstLetter = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const lowerCaseFirstLetter = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toLowerCase() + s.slice(1);
};

const capitalizeWords = (str) => {
  if (typeof str !== 'string') return '';
  const words = str.toLowerCase().split(' ');
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return capitalizedWords.join(' ');
};

export { lowerCaseFirstLetter, capitalizeWords };
export default uppercaseFirstLetter;
